import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import { TaskListTemplateModel } from '@domain-group/realhub-backend-api-types'

import { generateUrls } from '@hooks/useTaskListTemplate'

const generateTabBarItems = (taskListTemplate: TaskListTemplateModel) => {
  const urls = generateUrls(taskListTemplate)
  const { editTaskListTemplateUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editTaskListTemplateUrl,
      key: 'details',
      title: taskListTemplate?.title || 'Task List Template Details',
    },
  ]
}

export default generateTabBarItems
